import { ScreenSplitMode } from 'shared-types/ScreenSplit';
import { Playlist } from 'shared-types/playlist';

export enum BamSessionMode {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}
export enum BamApiOnlineStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export enum QUARTER_HOURS_COUNTS {
  THIRTY_MINUTES = 2,
  ONE_HOUR = 4,
  TWO_HOURS = 8,
}

export type BamProlongationState = {
  isProlongationPossiblePerTimeBlock: {
    [QUARTER_HOURS_COUNTS.THIRTY_MINUTES]: boolean;
    [QUARTER_HOURS_COUNTS.ONE_HOUR]: boolean;
    [QUARTER_HOURS_COUNTS.TWO_HOURS]: boolean;
  };
  isProlongationStateWaitingForChange: boolean;
  currentPricePerHour: null | number;
};

export type BamSessionUser = {
  clientCode: string | null;
  firstName: string | null;
  lastName: string | null;
  bamCustomerId: number | null;
  email: string | null;
  sessionStarted: boolean;
};

export type SessionState = {
  endTimestamp: number | null;
  remainingSessionTimeInMilliseconds: number | null;
  activatedVolume: boolean;
  shouldSkipStaffPassword: boolean;
  screenSplitMode: ScreenSplitMode;
  isStorageActivated: boolean;
  bamSessionMode: BamSessionMode;
  customPlaylists: null | Array<Playlist>;
  bamSessionUser: BamSessionUser;
  bamProlongation: BamProlongationState;
  isVideoRecording: boolean;
};
